import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Chip,
  Illustration,
  Link as DsLink,
  Typography,
} from '@saviynt/design-system';

import { INTEGRATION_ALL_TAB_STATIC_CARDS_DATA } from '../../constants/integrationsConstants';

import './IntegrationsPageAllTabStaticCards.css';

/**
 * Integration All Tab Static Cards Component
 */
function IntegrationAllTabStaticCards(): JSX.Element {
  const history = useHistory();

  const handleSelect = (appName: string) => {
    if (appName === 'Discovery') {
      history.push('/integrations/discovery');
    } else if (appName === 'Application') {
      history.push('/design/catalogManagement');
    } else {
      history.push('/');
    }
  };

  return (
    <div className='IntegrationsAllTabStaticCard'>
      <section className='Discovery-Container' aria-label='Discovery Content'>
        <div
          role='heading'
          aria-level={1}
          className='IntegrationsAllTabStaticCard-Container-Title'>
          Setup Integration
        </div>

        <div className='Discovery-Container-description'>
          <Typography kind='body2'>
            Discover your apps and workloads through one of these popular
            discovery sources. You&apos;ll unlock benefits like prefilled
            details, prioritized recommendations, and a full view of onboarded
            status.
            <DsLink
              className='IntegrationsAllTabStaticCard-Description-Link'
              text='Learn More'
              size='medium'
              suffixIconKind='JumpLink'
              dataTestId='integrations-dashboard-learnmore'
            />
          </Typography>
        </div>

        <section className='Discovery-Container-applications'>
          {INTEGRATION_ALL_TAB_STATIC_CARDS_DATA.map((app) => (
            <section
              key={app.id}
              className='IntegrationsAllTabStaticCard-Container'
              aria-labelledby={`card-title-${app.name}`}>
              {app.name === 'Discovery' && (
                <div className='IntegrationsAllTabStaticCard-Recommendation'>
                  <Chip kind='boldFilled' label='Recommended' color='info' />
                </div>
              )}
              <span
                className='IntegrationsAllTabStaticCard-Icon'
                aria-hidden='true'>
                <Illustration kind={app.kind} />
              </span>

              <header className='IntegrationsAllTabStaticCard-Header'>
                <Typography kind='h3' desktop='h3-d' mobile='h3-d'>
                  {app.displayName}
                </Typography>
                <Typography
                  kind='body2'
                  desktop='body2-d'
                  mobile='body2-d'
                  color='--color-foreground-neutral-subtle'>
                  {app.applicationGroup}
                </Typography>
              </header>

              <section
                className='IntegrationsAllTabStaticCard-Description'
                aria-labelledby={`desc-${app.name}`}>
                <Typography
                  kind='body2'
                  desktop='body2-d'
                  mobile='body2-d'
                  color='--color-foreground-neutral-subtle'>
                  {app.description}
                </Typography>
              </section>

              <span className='IntegrationsAllTabStaticCard-Button'>
                <Button
                  aria-label={`Select ${app.displayName}`}
                  type='button'
                  kind='subtle'
                  size='large'
                  onClick={() => handleSelect(app.name)}
                  dataTestId='integrations-dashboard-select'>
                  Select
                </Button>
              </span>
            </section>
          ))}
        </section>
      </section>
    </div>
  );
}

export default IntegrationAllTabStaticCards;
